import Panel from "./Panel.jsx";
import { formatZurichDateTime } from "../lib/utils/formatters.js";

function impactTone(impact) {
  if (impact === "very high") return "bg-rose/10 text-rose border-rose/30";
  if (impact === "high") return "bg-gold/10 text-goldSoft border-gold/30";
  return "bg-cyan/10 text-cyan border-cyan/30";
}

function impactLabel(impact) {
  if (impact === "very high") return "очень высокое";
  if (impact === "high") return "высокое";
  if (impact === "medium") return "среднее";
  return "низкое";
}

function isTodayZurich(value) {
  const format = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Zurich",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  return format.format(date) === format.format(new Date());
}

export default function EconomicCalendarPanel({ events = [] }) {
  return (
    <Panel title="Экономический календарь" icon="alert">
      <div className="space-y-3">
        {(events ?? []).slice(0, 8).map((event, index) => (
          <article key={`${event.name}-${index}`} className="rounded-md border border-white/10 bg-white/[0.03] p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <h3 className="text-sm font-semibold text-white">{event.name}</h3>
              <div className="flex flex-wrap gap-2">
                <span className={`rounded-md border px-2 py-1 text-xs font-semibold ${impactTone(event.impact)}`}>
                  {impactLabel(event.impact)}
                </span>
                {isTodayZurich(event.time) ? (
                  <span className="rounded-md border border-gold/30 bg-gold/10 px-2 py-1 text-xs font-semibold text-goldSoft">
                    Сегодня
                  </span>
                ) : null}
              </div>
            </div>
            <p className="mt-2 text-sm text-slate-300">{formatZurichDateTime(event.time)} · {event.country}</p>
            <div className="mt-3 grid grid-cols-3 gap-2 text-xs text-slate-400">
              <span>Пред.: <b className="text-slate-200">{event.previous ?? "н/д"}</b></span>
              <span>Прогноз: <b className="text-slate-200">{event.estimate ?? "н/д"}</b></span>
              <span>Факт: <b className="text-slate-200">{event.actual ?? "н/д"}</b></span>
            </div>
            <p className="mt-3 text-sm leading-snug text-slate-400">{event.goldRisk}</p>
          </article>
        ))}
      </div>
    </Panel>
  );
}
